const Tasks = [
  {
    id: 1,
    title: "Finish pending Homework",
    status: "To Do",
    date: "12 Sep",
  },
  {
    id: 187,
    title: "Complete Zuddl Assignment",
    status: "Done",
    date: "14 Sep",
  },
  {
    id: 145,
    title: "Bring Stationary tomorrow",
    status: "To Do",
    date: "15 Sep",
  },
  {
    id: 3,
    title: "Learn coding",
    status: "Doing",
    img: "https://images.ctfassets.net/mrop88jh71hl/60N2q8kDv42gi9xNIaSYJU/dacbb854f1f5e124643041f99e5f5c00/best-coding-languages-for-kids.jpeg?w=1024&h=684&fl=progressive&q=100&fm=jpg",
    date: "2 July",
  },
  {
    id: 2,
    title: "Take pet for a walk",
    status: "Resources",
    img: "https://noahapopka.com/wp-content/uploads/2018/10/AdobeStock_106985891-900x580@2x.jpeg",
    date :"12 Aug"
  },
  {
    id: 5,
    title: "Go to a vaccation",
    status: "Done",
    img: "https://www.razaproperties.net/wp-content/uploads/2017/07/beach.jpg",
    date: "13 Aug",
  },
  {
    id: 8,
    title: "Eat healthy food",
    status: "Done",
    date: "12 Aug",
  },
  {
    id: 17,
    title: "Solve Maths questions",
    status: "To Do",
    img: "https://img.freepik.com/premium-vector/maths-doodle-line-set-school-university-outline-subject_399998-71.jpg?w=2000",
    date: "3 Aug",
  },
  {
    id: 22,
    title: "GYM",
    status: "Resources",
    img: "https://static.toiimg.com/photo/96125662.cms",
    date: "20 Aug",
  },
];
export default Tasks;